import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/d4c6fcf69c7d885228da6e53459f8742/ce48a62436aa422819467cefe130a97b.jpeg"
              alt="CareJoint Logo"
              className="h-12 w-12 object-contain"
            />
            <div className="flex flex-col">
              <span className={`text-lg font-bold transition-colors ${isScrolled ? 'text-[#0B4F6C]' : 'text-white'}`}>
                CareJoint Physiotherapy
              </span>
              <span className={`text-xs transition-colors ${isScrolled ? 'text-[#14B8A6]' : 'text-white/90'}`}>
                Godbest
              </span>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('techniques')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Techniques
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#14B8A6] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#14B8A6] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#0D9488] transition-colors whitespace-nowrap"
            >
              Book Consultation
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-8 h-8 flex items-center justify-center"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('techniques')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Techniques
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#14B8A6] py-2 whitespace-nowrap"
            >
              Contact Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#14B8A6] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#0D9488] transition-colors whitespace-nowrap"
            >
              Book Consultation
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}